import React, { Fragment } from 'react';
import ContestLanding from '../common/ContestLanding';
import HmAjax from '../../util/HmAjax';
import futureCert from './images/Report/cont_res_in_future.png';
import AvailCert from './images/avail_certi.png';
import mock_in_progress from './images/Report/mock_in_progress.png';
import mock_in_future from './images/Report/mock_in_future.png';
import test_not_taken from './images/Report/test_not_taken.png';
import mock_complete from './images/Report/mock_complete.png';
import HmEventRegistry from '../../model/HmEventRegistry';

class ContestReport extends ContestLanding {
  constructor(props) {
    super(props);
    this.state = {
      downloadAvailable:false,
      submitbuttonDisabled:true,
      serverMsg:null,
      reportAvail:false,
      certitype:"bw",
      reportStatus:"",
      data:null
    };
    this.exportId=null;
    this.dashboardDropDownKey = "homeDropdown";
    this.getPDF=this.getPDF.bind(this);
    this.setChild(this,"CONTEST");
    this.percentile=0;
  }

  componentDidMount(){
    super.componentDidMount();
    //Eligible for last accessView
    this.setLastAccessView();
    this.showDownloadFn();
    HmEventRegistry.fireEvent("INITIATE_GA");
    HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
  }

  getPDF(){
    if(this.exportId!==null){
        this.setState({submitbuttonDisabled:true});
        this.dwnLdCertiFn(this.exportId);
    }else{
      this.generateCertificateFn();
    }
  }

  getContestStartTimeUIFn = (contestStartTime) => {
    return(
      <Fragment>
            <hr/>
          <div>
          <span className="mocktime">Round 1 Contest</span>&nbsp;:&nbsp;< span className="contesttime">{contestStartTime}</span>
          </div>
      </Fragment>
    )
  }

  getReportText(contestStage,response){
    let me=this;
    let userName = this.UserStore.getUserName() || this.UserStore.getLoginId();
    let mockStartTime = me.epochTimeFn(response.mockStartTime)+", "+this.formatAMPM(response.mockStartTime);
    let mockEndTime = me.epochTimeFn(response.mockEndTime)+", "+this.formatAMPM(response.mockEndTime);
    let contestStartTime = me.epochTimeFn(response.contestStartTime)+", "+this.formatAMPM(response.contestStartTime);
    let contestEndTime = me.epochTimeFn(response.contestEndTime)+", "+this.formatAMPM(response.contestEndTime);

      switch(contestStage){
        case "mock_start_date_in_future":
        return (
         
          <div>
             <div>
             <img src={mock_in_future}/>
            </div>
            <div className="username">Hello {userName}!</div> 
            <div><span className="mocktime">Mock Contest</span>&nbsp;:&nbsp;<span className="mocktime">{mockStartTime}</span>&nbsp;-&nbsp; 
            <span className="mocktime">{mockEndTime}</span>.</div>

            {
              (()=>{
                if(response.contestStartTime>0){
                  return me.getContestStartTimeUIFn(contestStartTime)
                }
              })()
            }
        </div>
        )
        case "mock_in_progress":
          switch(response.mockUserStatus){
            case "UN_ATTEMPTED":
                return(
                  <div>
                    <div>
                  <img src={test_not_taken}/>
                  </div>
                  <div className="username">Hello {userName}!</div> 
                  <div>Mock Contest&nbsp;:&nbsp;<span className="mocktime">{mockStartTime}</span>&nbsp;-&nbsp; 
                  <span className="mocktime">{mockEndTime}</span>.</div>
                  {
                      (()=>{
                        if(response.contestStartTime>0){
                          return me.getContestStartTimeUIFn(contestStartTime)
                        }
                      })()
                    }

                  {/* <hr/>
        
                    <div>
                    <span className="mocktime">Round 1 Contest</span>&nbsp;:&nbsp;< span className="contesttime">{contestStartTime}</span>
                    </div> */}
                </div>
                  )
            case "NEW":
            case "IN_PROGRESS":
                return(
                  <div>
                    <div>
                  <img src={mock_in_progress}/>
                  </div>
                   <div>Mock Contest: <span className="mocktime">{mockStartTime}</span>&nbsp;-&nbsp; 
                <span className="mocktime">{mockEndTime}</span>.</div>
                {
              (()=>{
                if(response.contestStartTime>0){
                  return me.getContestStartTimeUIFn(contestStartTime)
                }
              })()
            }
                {/* <hr/>
                    <div>
                    <span className="mocktime">Round 1 Contest</span>&nbsp;:&nbsp;< span className="contesttime">{contestStartTime}</span>
                    </div> */}
                </div>
                )
            case "COMPLETED":
                let mockUserScore = response.mockUserScore || 0;
                let mockTotalScore = response.mockTotalScore || 100;
                return( <div className="contcompleted">
                   <div className="row">
                   <div className="col-sm-12 col-md-8 col-lg-6 coldata">
                <h1 className="cong">Congratulations!</h1>
            <div className="result">You have successfully submitted <span className="mocktime">Mock Contest</span> of <span className="mocktime">{this.rb("title.round")}</span></div>
            <div>
            {me.rb("ri.score")} <span className="mocktime">Mock Contest</span>:&nbsp;<span className="mockscore">{mockUserScore}</span>&nbsp;out of <span className="mocktime">{mockTotalScore}</span> 
            </div>
                  </div>
                   </div>
                  {
                    (()=>{
                      if(response.contestStartTime>0){
                        return(
                          <div className="roundannounce">
                          <span className="mocktime COMPLETED">Round 1 Contest</span>&nbsp;:&nbsp;< span className="contesttime">{contestStartTime}</span>
                          </div>
                        )
                      }
                    })()
                  }
                  </div>
                )   
            default:
              return(
                <div>
                  {me.rb("no_data_available")}
                </div>
              )
          }
        case "contest_start_date_in_future":
            let mockUserScore = response.mockUserScore || null;
            let mockTotalScore = response.mockTotalScore || null;
        return (
          <div className="contstartfuture">
              <div>
            <img src={mock_complete}/>
            </div>
            <div>
            <div className="username">Good Luck!</div> 
              
              <span className="mocktime">Round 1 Contest</span> will be held on <span className="contesttime">{contestStartTime}</span>

              </div>
              {/* {(()=>{

                if(mockUserScore!==undefined && mockUserScore!==null){
                  return(
                    <div className="row">

                   <div className="mockscorebox">
                   {me.rb("ri.score")} <span className="mocktime">Mock Contest</span>:&nbsp;<span className="mockscore">{mockUserScore}</span>&nbsp;out of <span className="mocktime">{mockTotalScore}</span> 
                   </div>

                    </div>
                  )
                }
                
              })()
              } */}
        </div>
        )
        case "contest_in_progress":
            switch(response.liveUserStatus){
              case "UN_ATTEMPTED":
              case "NEW":
              case "IN_PROGRESS":
                  return(
                    <div className="contest_progress">
                      <div>
                    <img src={mock_complete}/>
                    </div>
                     <div> <span className="mocktime">{this.rb("contest.report.round1")}</span> is in Progress {/* <span className="contestendtime">{contestEndTime}</span> */}
                      </div>
                  </div>
                  )
              case "COMPLETED":
                  let resultDate = me.epochTimeFn(response.resultDate)+", "+me.formatAMPM(response.resultDate);
                  return( <div className="controundcompleted">
                     <div className="row">
                     <div className="col-sm-12 col-md-8 col-lg-6 coldata">
                  <h1 className="cong">Congratulations!</h1>
              <div className="result">You have successfully submitted  <span className="mocktime">{this.rb("round1.completed")}</span></div>
              <div>
              <img src={futureCert}/>
              </div>
                    </div>
                     </div>
                    <div className="roundannounce">
                     Result will be announced on <span className="resulttime">{resultDate}</span>
                      </div>
                    </div>
                  )   
              default:
                return(
                  <div>
                    {me.rb("no_data_available")}
                  </div>
                )
            }
        case "result_date_in_future":
            let resultDate = me.epochTimeFn(response.resultDate)+", "+me.formatAMPM(response.resultDate);
        return(
            <div className="controundcompleted">
              <div>
              <img src={futureCert}/>
              </div>
              <div className="roundannounce">
                  Result will be announced on  <span className="resulttime">{resultDate}</span>
               </div>
            </div>
        )
        case "result_date_in_past":
          switch(response.liveUserStatus)
          {
            case "UN_ATTEMPTED":
            case "NEW":
            case "IN_PROGRESS":
                return(
                  <div className="contest_progress">
                    <div>
                  <img src={mock_complete}/>
                  </div>
                    <div> <span className="mocktime">Round 1 Contest</span> started on &nbsp;<span className="contestendtime">{contestStartTime}</span>&nbsp;
                    ended on &nbsp;<span className="contestendtime">{contestEndTime}</span>
                    </div>
                </div>
                )
          }
        default:
        return(
          <div>
            {me.rb("no_data_available")}
          </div>
        )
    }
  }

  showDownloadFn(){
    var me = this;
  
    let contest_host =  this.getSelectedContestGroup();

    let formData = {
      "contestGroupId":contest_host
    } 

    var success = function(response){
     //console.log("response report ",response);
      if(response!==null){
          let errorMsg = "";
          let contestStage =  response.contestStage;
          let mockTxt = "";
          switch(contestStage){
              case "mock_start_date_in_future":
              case "mock_in_progress":
              case "contest_start_date_in_future":
              case "contest_in_progress":
              case "result_date_in_future":
              me.setState({reportAvail:true,downloadAvailable:false,serverMsg:'',reportStatus:contestStage,data:response})
              break;

              case "result_date_in_past":
                if(response.status==="success"){
                  me.percentile = response.percentile;
                  me.setState({downloadAvailable:true,submitbuttonDisabled:false,serverMsg:"",data:response})
                  
                  if(response.next_action==="download"){
                    me.exportId=response.exportId;
                  }
                }else{
                  me.setState({reportAvail:true,downloadAvailable:false,serverMsg:'',reportStatus:contestStage,data:response})
                }
              break;
              default:
                  errorMsg = me.rb("no_data_available");
                  me.setState({reportAvail:false,downloadAvailable:false,serverMsg:errorMsg});
          }
         
      }
     }

    var failure = function(err){
     // me.setState({serverMsg:""});No data available to generate report!
    }

    new HmAjax(this.getUrlFor("CONTEST_CERTI_STATUS"),formData).post(success, failure);
}

  generateCertificateFn(){
    var me = this;
  
    let contest_host =  this.getSelectedContestGroup();

    let formData = {
      "contestGroupId":contest_host
    } 
    me.setState({submitbuttonDisabled:true,serverMsg:""});
    var success = function(response){
    // console.log("response report ",response);
      if(response!==null){
        if(response.status=="success"){
          me.exportId=response.exportId;
          me.setState({submitbuttonDisabled:true,serverMsg:""});
          me.dwnLdCertiFn(response.exportId);
        }else{
          me.setState({submitbuttonDisabled:false,serverMsg:""});
        }
      }
     }

    var failure = function(err){
      me.setState({submitbuttonDisabled:false,serverMsg:""});
    }
    let certitype = this.state.certitype;
    new HmAjax(this.getUrlFor("CONTEST_CERTI_GENER")+"?color="+certitype,formData).post(success, failure);
}
  
  dwnLdCertiFn(exportId){
    let certitype = this.state.certitype;
    let contestId = (this.getSelectedContestGroup()) ? this.getSelectedContestGroup() : null;
    window.open(this.getUrlFor("CONTEST_CERTI_DWNLOD")+"/"+exportId+"?color="+certitype+"&contestHost="+contestId,"_blank");
    this.setState({submitbuttonDisabled:false});
  }
  
    render() {
      let me=this;
        return super.render(
          <div className="HomeComponent mt-40" id="ContestReport">

             {
               (()=>{
                if(this.state.downloadAvailable){
                  return(
                    <div id="ContestDwnld">
                <div className="container">	
                    <div className="row">
                      <div className="col-sm-12 col-md-9 col-lg-7 coldata">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                      <h1 className="cong">Congratulations!</h1>
                  {/* <div className="result">You have successfully submitted <span className="mocktime">{this.rb("round1.completed")}</span></div> */}
                        </div>

                       

                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div><span>{me.rb("ri.percentile")} <span className="mocktime">{this.rb("title.round")}</span>:&nbsp; </span><span className="percentage">{me.percentile}</span></div>
                        <div>
                        <hr/>
                        <img src={AvailCert}/>
                          </div>
                        <div onClick={this.getPDF}  className="contdwnlodbtn">
                        <span data-ga="Student - certificate download">Download certificate</span>
                        </div>
                        </div>
                        </div>

                      </div>

                </div>
            </div>
                  )
                }else{

                  if(this.state.reportAvail && this.state.data){
                    return (
                      <div className="reportAvail">
                        {me.getReportText(this.state.reportStatus,this.state.data)}
                      </div> 
                    )
                  }else{
                      return (
                        <div className="text-align-center">
                           {this.showLoader()}
                        </div> 
                      )
                  }


                }
               })()
             }

      </div>
      )
  }

}

export default ContestReport;


// WEBPACK FOOTER //
// ./src/views/contest/ContestReport.js